import React, { useState } from "react";
import { Form, Col, Row, Button, Table, Container } from "react-bootstrap";
import CustomFormCheck from "utils/CustomFormCheck";
import { v4 as uuidv4 } from "uuid";
import jsDig from "utils/jsDig";

export default function GoogleAnalyticsGoals(props) {
  const [customGoals, setCustomGoals] = useState(props.customGoals);
  const [customGoalsEnabled, setCustomGoalsEnabled] = useState(props.customGoalsEnabled);
  const accountLabels = props.analyticsAccounts;
  const [selectedAccount, setSelectedAccount] = useState(accountLabels[0] && accountLabels[0].id ? accountLabels[0].id : "");

  const handleDelete = (targetKey, targetIndex) => {
    let newData = { ...customGoals };

    if (jsDig([targetKey, targetIndex], newData)) {
      newData[targetKey] = newData[targetKey].filter((goal, index) => {
        return targetIndex != index;
      });
    }
    setCustomGoals(newData);
  };

  const handleChange = (targetKey, targetIndex, property, value) => {
    let newData = { ...customGoals };
    if (jsDig([targetKey, targetIndex], newData)) {
      newData[targetKey][targetIndex][property] = value;
    }
    setCustomGoals(newData);
  };

  const addGoal = (targetKey) => {
    let newData = { ...customGoals };

    if (jsDig([targetKey], newData)) {
      newData[targetKey].push({});
    } else {
      newData[targetKey] = [{}];
    }
    setCustomGoals(newData);
  };

  return (
    <>
       <Row className="pt-3 align-items-center">
        <Col xs={"auto"} className="pr-0">
          <CustomFormCheck
            id="custom-analytics-goals-enabled"
            name="custom_analytics_goals_enabled"
            checked={customGoalsEnabled}
            onChange={() => setCustomGoalsEnabled(!customGoalsEnabled)}
            label="Track goals from Google Analytics"
         />
       </Col>
      </Row>
      <Row className="pt-3 align-items-center">
        <Col xs={"auto"}>
          <p className="f16 mb-2 mb-md-0">Select Label/ID:</p>
        </Col>
        <Col xs={"auto"} lg={6}>
          <Form.Control
            readOnly={!customGoalsEnabled}
            className="ml-0 primary ga-for analytics-goals-domain-selector"
            size="sm"
            as="select"
            defaultValue={selectedAccount}
            onChange={(e) => setSelectedAccount(e.target.value)}>
            {accountLabels.map((label) => {
              if (label.id) {
                return (
                  <option key={label.id} value={label.id}>
                    {label.label &&
                      label.label
                        .split("_")
                        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                        .join(" ")}
                    {` - ${label.id}`}
                  </option>
                );
              }
            })}
          </Form.Control>
        </Col>
      </Row>
      <Row className="py-3">
        <Col xs={"auto"} lg={9}>
          <p className="f10 primary">
            Select the label/ID to track goals for, and set/name the goals below. Note: If you have just added a new ID above, you will need to save and refresh
            before it will appear in this section.
          </p>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col>
          <div className="table-responsive pb-3">
            <table className="gag-table t1">
              <thead>
                <tr className="pl-3">
                  <td className="pl-3"></td>
                  <td className="pl-3"></td>
                  <td className="pl-2">Label</td>

                  <td style={{ width: "40%" }}></td>
                </tr>
              </thead>
              <tbody>
                {accountLabels.map((label) => {
                  if (label.id) {
                    if (customGoals[label.id]) {
                      return (
                        <React.Fragment key={label.id}>
                          {customGoals[label.id].map((goalData, index) => {
                            return (
                              <tr key={index} style={{ display: label.id == selectedAccount ? "table-row" : "none" }}>
                                <td>
                                  <CustomFormCheck
                                    sendUncheckedValue
                                    readOnly={!customGoalsEnabled}
                                    name={`[custom_analytics_goals][${label.id}][][enabled]`}
                                    id={`custom-analytics-goal-${label.id}-${index}-enabled`}
                                    checked={jsDig(["enabled"], goalData) == "1" ? true : false}
                                    onChange={(e) => handleChange(label.id, index, "enabled", e.target.checked ? "1" : "0")}
                                  />
                                </td>
                                <td>
                                  <Form.Control
                                    style={{ width: "116px" }}
                                    readOnly={!customGoalsEnabled}
                                    name={`[custom_analytics_goals][${label.id}][][goal]`}
                                    className="primary"
                                    size="sm"
                                    as="select"
                                    value={jsDig(["goal"], goalData) ? jsDig(["goal"], goalData) : ""}
                                    onChange={(e) => handleChange(label.id, index, "goal", e.target.value)}>
                                    <option value="" hidden disabled>
                                      Choose one
                                    </option>
                                    {[...Array(20)].map((e, i) => {
                                      let goalNumber = i + 1;
                                      return (
                                        <option key={goalNumber} value={goalNumber}>
                                          Goal {goalNumber}
                                        </option>
                                      );
                                    })}
                                  </Form.Control>
                                </td>
                                <td className="pl-2">
                                  <Form.Control
                                    style={{ width: "211px" }}
                                    readOnly={!customGoalsEnabled}
                                    name={`[custom_analytics_goals][${label.id}][][label]`}
                                    size="sm"
                                    value={jsDig(["label"], goalData) ? jsDig(["label"], goalData) : ""}
                                    onChange={(e) => handleChange(label.id, index, "label", e.target.value)}
                                  />
                                </td>
                                <td>
                                  {(index >= 0 && customGoals[label.id].length > 1) && (
                                    <i
                                      className="pl-2 fas fa-minus-circle"
                                      onClick={() => {
                                        handleDelete(label.id, index);
                                      }}></i>
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                        </React.Fragment>
                      );
                    }
                  }
                })}
              </tbody>
            </table>
          </div>
          <div className="text-center text-md-left">
            <Button
              className="mt-3 mb-3 ml-2 mr-4  py-1"
              style={{ paddingLeft: "40px", paddingRight: "40px" }}
              size="sm"
              as="input"
              type="button"
              onClick={() => {
                addGoal(selectedAccount);
              }}
              value="+ Add goal"
              variant="success"
            />
          </div>
        </Col>
      </Row>
    </>
  );
}
